import { render, staticRenderFns } from "./WsContentTitle.vue?vue&type=template&id=fd394f84&"
import script from "./WsContentTitle.vue?vue&type=script&lang=js&"
export * from "./WsContentTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports